import {
  WSTable,
  WSTableItem,
  WSTableToolbar
} from "@wingspanhq/fe-component-library";
import { useMemo, useState } from "react";

import { PaystubSummary } from "../../types";

import { getColumns } from "./columns";

type Props = {
  items: PaystubSummary[];
  loading?: boolean;
  onDownload?: () => void;
  onRowOpen?: (id: string) => void;
};

export const TablePaystubs: React.FC<Props> = props => {
  const [selection, setSelection] = useState<WSTableItem<PaystubSummary>[]>([]);

  const tableData = useMemo<WSTableItem<PaystubSummary>[]>(
    () => props.items.map(item => ({ id: item.id, data: item })),
    [props.items]
  );
  const columns = useMemo(() => getColumns(), []);

  return (
    <>
      {selection.length > 0 && (
        <WSTableToolbar
          actions={[
            // TODO: wire up bulk paystub actions once the service is available.
            { label: "Download summaries", onClick: () => props.onDownload?.() }
          ]}
          actionsLabel="Bulk actions"
          count={selection.length}
          mb="M"
          onClear={() => setSelection([])}
        />
      )}

      <WSTable<PaystubSummary>
        columns={columns}
        headerAction={
          props.onDownload
            ? { icon: "download", onClick: props.onDownload }
            : undefined
        }
        loading={props.loading}
        rowMenuActions={item => [
          {
            icon: "file",
            label: "View details",
            onClick: () => props.onRowOpen?.(item.id)
          },
          {
            icon: "download",
            label: "Download paystub",
            onClick: () => props.onDownload?.()
          }
        ]}
        selection={selection}
        tableData={tableData}
        onRowClick={item => props.onRowOpen?.(item.id)}
        onSelectionChange={setSelection}
      />
    </>
  );
};
